import DOMPurify, { Config as DOMPurifyConfig } from 'dompurify';

const sanitizeConfig: DOMPurifyConfig = {
  ALLOWED_TAGS: ['b', 'i', 'u', 'strong', 'em', 'a', 'p', 'br'],
  ALLOWED_ATTR: ['href', 'title'],
  FORBID_ATTR: ['style', 'onerror', 'onclick', 'onload'],
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
};

export function deepSanitize<T>(data: T): T {
  if (typeof data === 'string') {
    return DOMPurify.sanitize(data, sanitizeConfig) as unknown as T;
  }

  if (Array.isArray(data)) {
    return data.map((item) => deepSanitize(item)) as unknown as T;
  }

  if (data && typeof data === 'object') {
    const sanitizedObj: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(data)) {
      sanitizedObj[key] = deepSanitize(value);
    }
    return sanitizedObj as T;
  }

  return data;
}
